import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Plus, Search } from 'lucide-react';

const ContactsTable = () => {
  const [contacts] = useState([
    {
        name: "Katherine Beckinsdale",
        email: "katherinebeck@yahoo.com",
        mashScore: 2,
        phone: "(214) 948 4392",
        address: "321 Wellshire Court, Plano TX 75082",
        lastContact: "August 21, 2023",
        image: '/images/agent2.jpg' // Frau
      },
      {
        name: "Clyde Davenport",
        email: "dclydge9147@gmail.com",
        mashScore: 3,
        phone: "(469) 847 2098",
        address: "1400 Lavender Place, Memphis, TN 06982",
        lastContact: "September 28, 2023",
        image: '/images/agent1.jpg' // Mann
      },
      {
        name: "JP Earnest",
        email: "jpearnest@jpii.org",
        mashScore: 1,
        phone: "(214) 545 6214",
        address: "8209 Warren Pkwy, Suite 200, Dallas, TX 74018",
        lastContact: "December 29, 2023",
        image: '/images/agent1.jpg' // Mann
      },
      {
        name: "Rose Saunders",
        email: "rosesaunders@yahoo.com",
        mashScore: 1,
        phone: "(214) 948 4392",
        address: "2984 Eastern Bay Street, Plano, TX 48108",
        lastContact: "January 2, 2024",
        image: '/images/agent2.jpg' // Frau
      },
      {
        name: "Ashley Jedd",
        email: "ashishere@gmail.com",
        mashScore: 2,
        phone: "(481) 381 9848",
        address: "48108 Maple Street, Atlanta, GA 31057",
        lastContact: "January 2, 2024",
        image: '/images/agent2.jpg' // Frau
      },
      {
        name: "Peter Franklin",
        email: "peterfrank@peterfrank.com",
        mashScore: 2,
        phone: "(214) 948 4392",
        address: "2810 Half Pecon Street, Plano, TX 74929",
        lastContact: "January 2, 2024",
        image: '/images/agent1.jpg' // Mann
      },
      {
        name: "James Bullet",
        email: "james490bullet@gmail.com",
        mashScore: 3,
        phone: "(214) 948 4392",
        address: "1400 Lavender Place, Memphis, TN 06982",
        lastContact: "January 20, 2024",
        image: '/images/agent1.jpg' // Mann
      },
      {
        name: "Thomas Wilmington",
        email: "tomwil@gmail.com",
        mashScore: 2,
        phone: "(469) 847 2098",
        address: "321 Wellshire Court, Plano TX 75082",
        lastContact: "January 20, 2024",
        image: '/images/agent1.jpg' // Mann
      },
      {
        name: "Katherine Beckinsdale",
        email: "katherinebeck@yahoo.com",
        mashScore: 2,
        phone: "(214) 948 4392",
        address: "8209 Warren Pkwy, Suite 200, Dallas, TX 74018",
        lastContact: "January 20, 2024",
        image: '/images/agent2.jpg' // Frau
      },
      {
        name: "Katherine Beckinsdale",
        email: "katherinebeck@yahoo.com",
        mashScore: 1,
        phone: "(478) 391 3847",
        address: "459 Markers Street, Plano, TX 74929",
        lastContact: "January 20, 2024",
        image: '/images/agent2.jpg' // Frau
      }
    ]);
  

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center gap-4">
          <button className="p-2 text-gray-500 hover:bg-gray-100 border rounded">
            <ChevronLeft className="w-4 h-4" />
          </button>
          <button className="p-2 text-gray-500 hover:bg-gray-100 border rounded">
            <ChevronRight className="w-4 h-4" />
          </button>
          <button className="p-2 text-gray-500 hover:bg-gray-100 border rounded">
            Filter
          </button>
        </div>

        <div className="flex items-center gap-4">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
            <input 
              type="text"
              placeholder="Search..."
              className="pl-10 pr-4 py-2 border rounded-lg w-64"
            />
          </div>
          <button className="bg-[#94CA3C] hover:bg-[#a1e632] text-white px-4 py-2 rounded-lg flex items-center gap-2">
          <Plus className="w-4 h-4" />
          ADD CONTACT
          </button>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow">
        <table className="w-full">
          <thead>
            <tr className="border-b bg-gray-50">
              <th className="p-4 w-8">
                <input type="checkbox" className="rounded border-gray-300" />
              </th>
              <th className="p-4 text-left font-medium text-gray-600">Contact</th>
              <th className="p-4 text-left font-medium text-gray-600">Email</th>
              <th className="p-4 text-left font-medium text-gray-600">SmashScore</th>
              <th className="p-4 text-left font-medium text-gray-600">Phone</th>
              <th className="p-4 text-left font-medium text-gray-600">Address</th>
              <th className="p-4 text-left font-medium text-gray-600">Last Contact Date</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {contacts.map((contact, index) => (
              <tr key={index} className="hover:bg-gray-50">
                <td className="p-4">
                  <input type="checkbox" className="rounded border-gray-300" />
                </td>
                <td className="p-4">
                  <div className="flex items-center gap-3">
                    <img 
                      src={contact.image} 
                      alt={contact.name}
                      className="w-8 h-8 rounded-full object-cover"
                    />
                    <span className="font-medium text-gray-900">{contact.name}</span>
                  </div>
                </td>
                <td className="p-4 text-gray-600">{contact.email}</td>
                <td className="p-4">
  <div className="flex items-center gap-2">
    <div className={`w-6 h-6 rounded-full flex items-center justify-center
      ${contact.mashScore === 1 ? 'bg-green-100 text-green-600' :
      contact.mashScore === 2 ? 'bg-yellow-100 text-yellow-600' :
      'bg-red-100 text-red-600'}`}>
      {contact.mashScore}
    </div>
    <div className="w-24 h-2 rounded-full overflow-hidden bg-gray-100">
      <div 
        className={`h-full ${
          contact.mashScore === 1 ? 'bg-green-500' :
          contact.mashScore === 2 ? 'bg-yellow-500' :
          'bg-red-500'
        }`}
        style={{
          width: `${contact.mashScore === 1 ? '100%' :
                   contact.mashScore === 2 ? '66%' :
                   '33%'}`
        }}
      />
    </div>
  </div>
</td>
                <td className="p-4 text-gray-600">{contact.phone}</td>
                <td className="p-4 text-gray-600">{contact.address}</td>
                <td className="p-4">
                  <div className="flex items-center gap-2">
                    <div className="w-4 h-4">
                      <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4 text-gray-400">
                        <path d="M8 2V5M16 2V5M3.5 9.09H20.5M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    <span className="text-gray-600">{contact.lastContact}</span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="p-4 flex items-center justify-between border-t">
          <div className="text-sm text-gray-500">
            Showing 1-10 of 100 contacts
          </div>
          <div className="flex items-center gap-2">
            <button className="p-2 text-gray-500 border rounded hover:bg-gray-50">
              <ChevronLeft className="w-4 h-4" />
            </button>
            {[1, 2, 3, 4, 5].map((page) => (
              <button 
                key={page}
                className={`w-8 h-8 flex items-center justify-center rounded-lg ${
                  page === 1 ? 'bg-gray-200' : 'hover:bg-gray-100'
                }`}
              >
                {page}
              </button>
            ))}
            <button className="p-2 text-gray-500 border rounded hover:bg-gray-50">
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactsTable;